import { Navigate, Outlet } from 'react-router-dom';
import { useUserClientsWithActiveClient } from 'domains/auth/UserClientsWrapper/useUserClients';
import { getClientRedirect, OnboardingStatus } from 'domains/client';

type Props = {
  statuses: OnboardingStatus[];
  children?: React.ReactNode;
};

export const RequireOnboardingStatus = ({ statuses, children = <Outlet /> }: Props): JSX.Element | null => {
  const { activeClient } = useUserClientsWithActiveClient();

  if (!statuses.includes(activeClient.onboardingStatus)) {
    return <Navigate to={getClientRedirect(activeClient)} />;
  }

  return <>{children}</>;
};
